export default __webpack_public_path__ + "static/media/automation.a604addd.png";